import type { Gender, PronounType } from './getPronoun';
import { getPronoun } from './getPronoun';

export function getPronounByPetGenders(
  type: PronounType,
  petGenders: Gender[]
): string {
  const petCount = petGenders.length;
  const pronoun = (petCount === 1 && petGenders[0]) || 'none';

  return getPronoun(pronoun, type);
}
